__turbopack_context__.v({
  "onlyTextContainer": "AgencyTeamTextOnlySlider-module-scss-module__1vxK4a__onlyTextContainer",
});
